import TableLoader from "../../../../../general/table/tableLoader";
import EmptyRow from "../../../../../general/table/emptyRow";
import React from "react";
import VisitParaclinicalPrescriptionTableRowItem from "./visitParaclinicalPrescriptionTable_rowItem";

type VisitParaclinicalPrescriptionTableProps = {
  dataList?: any;
  dataListTitles: string[];
  isRequesting: boolean
}

const VisitParaclinicalPrescriptionTable = ({
  dataList,
  dataListTitles,
  isRequesting
}: VisitParaclinicalPrescriptionTableProps) => {
  const _dataListTitles = dataListTitles.map((item, i) => <td key={i}>{item}</td>),
    _dataList = dataList && dataList.length > 0 && dataList.map((item: any, i: number) => {
      return <VisitParaclinicalPrescriptionTableRowItem item={item} key={i}/>
    });

  return (
    <table>
      <thead>
      <tr>
        {_dataListTitles}
      </tr>
      </thead>
      <tbody>
      {isRequesting ?
        <TableLoader colSpan={dataListTitles.length}/> :
        _dataList ? _dataList : <EmptyRow colSpan={dataListTitles.length} content={''}/>
      }
      </tbody>
    </table>
  )
}

export default VisitParaclinicalPrescriptionTable;
